
/**
 * keepalive 缓存页面
 */
const keepAlive = {
  state: {
    includes: [],
  },
  mutations: {
    ADD_KEEPALIVE(state, router) {
      state.includes.push(router)
    },
    DELETE_KEEPALIVE(state, router) {
      state.includes.forEach((val, index) => {
        if (val == router) {
          state.includes.splice(index, 1)
        }
      })
    },
  },
  actions: {
    addKeepAlive({ commit }, router) {
      commit('ADD_KEEPALIVE', router)
    },
    deleteKeepAlive({ commit }, router) {
      commit('DELETE_KEEPALIVE', router)
    },
  },
}

export default keepAlive